<!-- Pass有効化前 -->
<template>
  <!-- パス使用前の確認ダイアログ -->
  <ItemDialog ref="DialogPassChangeToValid" image-type="alert">
    <template #content-area>
      <p>このチケットの利用を開始します。よろしいですか？</p>
    </template>
    <template #button-area>
      <ItemButton label="OK" action-type="btn-primary" @clicked="clickOk" />
      <ItemButton
        label="キャンセル"
        action-type="btn-cancel"
        @clicked="closeDialog"
      />
    </template>
  </ItemDialog>
  <!-- パス使用前の確認ダイアログ -->
</template>

<script>
import { onMounted, computed, watchEffect, ref } from "vue";

export default {
  name: "DialogPassChangeToValid",
  props: {
    clickOk: { type: Function, required: true },
  },
  setup() {
    const DialogPassChangeToValid = ref(null);

    const openDialog = () => {
      DialogPassChangeToValid.value.open();
    };

    const closeDialog = () => {
      DialogPassChangeToValid.value.close();
    };

    return {
      DialogPassChangeToValid,
      openDialog,
      closeDialog,
    };
  },
};
</script>
